import React from 'react';
import { Card, Descriptions, Typography, Space } from 'antd';
import { PhoneOutlined, MailOutlined, UserOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const Help = () => {
  // Hardcoded Super Admin contact info as per request.
  // Ideally, this could come from a configuration or API.
  const adminContact = {
    name: 'Mr.NOOR AKKOJI',
    email: 'info@sharkfragrance.com',
    phone: '+91 89709 21290', // Placeholder phone number
    role: 'Administrator'
  };

  return (
    <div style={{ maxWidth: 800, margin: '0 auto' }}>
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <div>
          <Title level={2}>Help & Support</Title>
          <Text type="secondary">Contact the administrator for any assistance or queries.</Text>
        </div>

        <Card title="Admin Contact Information" bordered={false} style={{ boxShadow: '0 1px 2px 0 rgba(0,0,0,0.05)' }}>
          <Descriptions column={1} bordered size="middle">
            <Descriptions.Item label={<Space><UserOutlined /> Name</Space>}>
              {adminContact.name}
            </Descriptions.Item>
            <Descriptions.Item label={<Space><MailOutlined /> Email</Space>}>
              <a href={`mailto:${adminContact.email}`}>{adminContact.email}</a>
            </Descriptions.Item>
            <Descriptions.Item label={<Space><PhoneOutlined /> Mobile</Space>}>
              <a href={`tel:${adminContact.phone}`}>{adminContact.phone}</a>
            </Descriptions.Item>
            <Descriptions.Item label="Role">
              {adminContact.role}
            </Descriptions.Item>
          </Descriptions>
        </Card>

        <Card title="Frequently Asked Questions" bordered={false} style={{ boxShadow: '0 1px 2px 0 rgba(0,0,0,0.05)' }}>
          <Space direction="vertical" size="middle">
            <div>
              <Text strong>Q: How do I calculate my commission?</Text>
              <br />
              <Text>A: Commission is calculated at 10% of the total order amount for verified orders.</Text>
            </div>
            <div>
              <Text strong>Q: When will I receive my payout?</Text>
              <br />
              <Text>A: Payouts are processed weekly for all verified and completed orders.</Text>
            </div>
          </Space>
        </Card>
      </Space>
    </div>
  );
};

export default Help;
